import mixpanel from "mixpanel-browser";
import {
  GameRound,
  isMixPuzzleRound,
  MixPuzzleRound,
} from "shared/games/types/GameRound";
import { gameStarted } from "./mixpanel/gameEvents";

export interface TrackGameStartParams {
  round: GameRound | MixPuzzleRound;
  context:
    | "mixpuzzle//featured"
    | "mixpuzzle//grid"
    | "crystal-ball//dashboard"
    | "crystal-ball//end-game"
    | "mix-ear-training-selector//basic"
    | "mix-ear-training-selector//advanced"
    | "guided-path";
}

export default function trackGameStart({
  round,
  context,
}: TrackGameStartParams) {
  const { difficulty } = round;

  mixpanel.track(gameStarted.event, {
    [gameStarted.properties.type]: isMixPuzzleRound(round)
      ? "mixpuzzle"
      : "mix-ear-training",

    [gameStarted.properties.difficulty]: difficulty,

    [gameStarted.properties.context]: context,

    [gameStarted.properties.games]: isMixPuzzleRound(round) ? [] : round.games,

    [gameStarted.properties.instruments]: isMixPuzzleRound(round)
      ? []
      : round.instruments,

    [gameStarted.properties.techniques]: isMixPuzzleRound(round)
      ? []
      : round.techniques,
  });
}
